var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { produce } from 'immer';
import { useEffect, useReducer } from 'react';
import { deleteMedicationListEntry, getMedicationList, searchMedicationListEntries, updateMedicationListEntry } from '../../Async/MedicationListsAsync';
import { AutosaveStates } from '../../Components/AutosaveIndicator';
import { useError } from '../../Components/ErrorBoundary';
import { displayMessage } from '../../Config/ApplicationConfig';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
import { useDebounce } from '../../Hooks/useDebounce';
import { CancelledRequest, useHttpConfig } from '../../Shared/HttpRequestExecutor';
export var EntryLoadingState;
(function (EntryLoadingState) {
    EntryLoadingState[EntryLoadingState["Init"] = 0] = "Init";
    EntryLoadingState[EntryLoadingState["Loading"] = 1] = "Loading";
    EntryLoadingState[EntryLoadingState["Loaded"] = 2] = "Loaded";
    EntryLoadingState[EntryLoadingState["Refreshing"] = 3] = "Refreshing";
})(EntryLoadingState || (EntryLoadingState = {}));
export var MedListLoadingState;
(function (MedListLoadingState) {
    MedListLoadingState[MedListLoadingState["Init"] = 0] = "Init";
    MedListLoadingState[MedListLoadingState["Loading"] = 1] = "Loading";
    MedListLoadingState[MedListLoadingState["Loaded"] = 2] = "Loaded";
})(MedListLoadingState || (MedListLoadingState = {}));
var reducer = produce(function (state, action) {
    switch (action.type) {
        case 'BulkActionCancel':
            state.takeBulkAction = null;
            break;
        case 'QueryUpdate':
            state.query = action.query;
            break;
        case 'MedicationListLoading':
            state.medicationListLoadingState = MedListLoadingState.Loading;
            break;
        case 'MedicationListLoaded':
            state.medicationList = action.medicationList;
            state.medicationListLoadingState = MedListLoadingState.Loaded;
            break;
        case 'MedicationListEntriesLoading':
            if (state.entryLoadingState == EntryLoadingState.Loaded)
                state.entryLoadingState = EntryLoadingState.Refreshing;
            else
                state.entryLoadingState = EntryLoadingState.Loading;
            break;
        case 'MedicationListEntriesLoaded':
            state.entries = action.medicationListEntries;
            state.entryLoadingState = EntryLoadingState.Loaded;
            state.queryUsed = action.queryUsed;
            break;
        case 'BulkActionTrigger':
            state.takeBulkAction = action.action;
            break;
        case 'BulkActionSuccess':
            state.query = '';
            state.takeBulkAction = null;
            break;
        case 'PublishedToggle':
            if (state.medicationList)
                state.medicationList.status = action.published
                    ? MedicationListStatus.Published
                    : MedicationListStatus.Draft;
            break;
        case 'RowSavingComplete':
            state.editRowId = '';
            state.updatingRow = false;
            state.entries = state.entries.map(function (it) {
                if (it.id === action.row.id)
                    return action.row;
                return it;
            });
            break;
        case 'RowEditStart':
            state.editRowId = action.rowId;
            break;
        case 'RowEditCancel':
            state.editRowId = '';
            break;
        case 'RowSavingStarted':
            state.updatingRow = true;
            break;
        case 'DeleteEntryStart':
            state.deleteRow = action.row;
            break;
        case 'DeleteEntryStarting':
            state.deletingRow = true;
            break;
        case 'DeleteEntryCancel':
            state.deleteRow = null;
            break;
        case 'DeleteEntryComplete':
            state.deletingRow = false;
            if (state.deleteRow) {
                state.entries = state.entries.filter(function (it) { var _a; return it.id !== ((_a = state.deleteRow) === null || _a === void 0 ? void 0 : _a.id); });
                state.deleteRow = null;
            }
            break;
    }
});
export function useMedicationListState(props) {
    var _this = this;
    var throwError = useError();
    var _a = __read(useReducer(reducer, {
        medicationListLoadingState: MedListLoadingState.Init,
        medicationList: null,
        entries: [],
        entryLoadingState: EntryLoadingState.Init,
        query: '',
        queryUsed: '',
        takeBulkAction: null,
        editRowId: '',
        updatingRow: false,
        deleteRow: null,
        deletingRow: false
    }), 2), state = _a[0], dispatch = _a[1];
    var getConfig = useHttpConfig();
    var loadMedicationList = function () { return __awaiter(_this, void 0, void 0, function () {
        var medList, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'MedicationListLoading'
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getMedicationList(getConfig, props.medListId)];
                case 2:
                    medList = _a.sent();
                    if (medList instanceof CancelledRequest)
                        return [2 /*return*/];
                    dispatch({
                        type: 'MedicationListLoaded',
                        medicationList: medList
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    throwError(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var listConfig = useHttpConfig();
    var loadEntries = function (query) { return __awaiter(_this, void 0, void 0, function () {
        var filter, entries, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'MedicationListEntriesLoading'
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    filter = {};
                    return [4 /*yield*/, searchMedicationListEntries(listConfig, props.medListId, query, 101, filter)];
                case 2:
                    entries = _a.sent();
                    if (entries instanceof CancelledRequest)
                        return [2 /*return*/];
                    dispatch({
                        type: 'MedicationListEntriesLoaded',
                        medicationListEntries: entries,
                        queryUsed: query
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    throwError(e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadMedicationList();
    }, []);
    var debounceQuery = useDebounce(state.query);
    useEffect(function () {
        loadEntries(debounceQuery);
    }, [debounceQuery]);
    var refreshEntries = function () {
        loadEntries(debounceQuery);
    };
    var reloadMedicationList = function () {
        loadMedicationList();
        loadEntries(debounceQuery);
    };
    var handleSaveMedication = function (newData) { return __awaiter(_this, void 0, void 0, function () {
        var payload, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    payload = __assign({}, newData);
                    return [4 /*yield*/, updateMedicationListEntry(props.medListId, newData.id, payload)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'RowSavingComplete', row: newData });
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    throwError(e_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteMedication = function () { return __awaiter(_this, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'DeleteEntryStarting' });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!state.deleteRow) return [3 /*break*/, 3];
                    return [4 /*yield*/, deleteMedicationListEntry(props.medListId, state.deleteRow.id)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    dispatch({ type: 'DeleteEntryComplete' });
                    refreshEntries();
                    return [3 /*break*/, 5];
                case 4:
                    e_4 = _a.sent();
                    throwError(e_4);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var showDeleteMedicationDialog = function (rowData) {
        dispatch({ type: 'DeleteEntryStart', row: rowData });
    };
    var cancelDeleteMedication = function () {
        dispatch({ type: 'DeleteEntryCancel' });
    };
    var handlePublishedToggled = function (published) {
        dispatch({ type: 'PublishedToggle', published: published });
    };
    var startRowEditing = function (row) {
        dispatch({ type: 'RowEditStart', rowId: row.id });
    };
    var cancelRowEditing = function () {
        dispatch({ type: 'RowEditCancel' });
    };
    var updateQuery = function (query) {
        dispatch({ type: 'QueryUpdate', query: query });
    };
    var showBulkActionWizard = function (action) {
        dispatch({ type: 'BulkActionTrigger', action: action });
    };
    var cancelBulkAction = function () {
        dispatch({ type: 'BulkActionCancel' });
    };
    var bulkActionComplete = function (result) {
        if (!!result.itemsAdded || !!result.itemsRemoved) {
            var message = [
                result.itemsAdded > 0 ? result.itemsAdded + " items added to list." : '',
                result.itemsRemoved > 0 ? result.itemsRemoved + " items removed from list." : ''
            ]
                .filter(function (it) { return !!it; })
                .join(' ');
            displayMessage(message);
        }
        else {
            displayMessage('No items effected.');
        }
        dispatch({ type: 'BulkActionSuccess' });
        refreshEntries();
    };
    var autoSaveStatus = state.updatingRow ? AutosaveStates.saving : AutosaveStates.saved;
    return {
        state: state,
        autoSaveStatus: autoSaveStatus,
        updateQuery: updateQuery,
        startRowEditing: startRowEditing,
        cancelRowEditing: cancelRowEditing,
        cancelBulkAction: cancelBulkAction,
        reloadMedicationList: reloadMedicationList,
        handleSaveMedication: handleSaveMedication,
        showBulkActionWizard: showBulkActionWizard,
        refreshEntries: refreshEntries,
        bulkActionComplete: bulkActionComplete,
        handleDeleteMedication: handleDeleteMedication,
        handlePublishedToggled: handlePublishedToggled,
        cancelDeleteMedication: cancelDeleteMedication,
        showDeleteMedicationDialog: showDeleteMedicationDialog
    };
}
